import React, { useState } from 'react';
import { Modal, TextField, Button, Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import apiInstance from '../../../services/ServiceApi';

const TelefonoAdd = ({ cliente, onTelefonoAgregado }) => {
    const [telefono, setTelefono] = useState('');
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleGuardarTelefono = () => {
        apiInstance.post('telefono/', {
            cliente,
            telefono,
        })
        .then(response => {
            onTelefonoAgregado(telefono);
            handleClose();
        })
        .catch(error => {
            console.error('Error al guardar el teléfono:', error);
            handleClose();
        });
    };

    return (
        <div>
            <Fab color="primary" aria-label="add" onClick={handleOpen}>
                <AddIcon />
            </Fab>
            <Modal open={open} onClose={handleClose}>
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: '#fff',
                    padding: '1rem'
                }}>
                    <TextField
                        label="Teléfono"
                        value={telefono}
                        onChange={e => setTelefono(e.target.value)}
                        fullWidth
                    />
                    <Button variant="contained" onClick={handleGuardarTelefono}>
                        Guardar Teléfono
                    </Button>
                </div>
            </Modal>


        </div>
    );
};

export default TelefonoAdd;
